import { HEX_292D38, HEX_66AAFF, HEX_E2E8F0 } from '@tanium/colors';
import { getRgbString } from '@tanium/coreui-utils';
import { defineColor, defineThemeValue } from '@tanium/react-theme-definition';

export const GuidelineStroke = defineColor([HEX_292D38, HEX_66AAFF]);
export const GuidelineShadowFloodColor = defineThemeValue([undefined, getRgbString(HEX_E2E8F0, '0.8')]);
